<div class="uni-loader">
  <div class="uni-loader__wrapper">
    <div class="uni-loader__spinner">
      <ng-lottie
        [options]="options"
      ></ng-lottie>
    </div>
  </div>
</div>
